var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300.56 314.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3{fill-rule:evenodd;}.cls-2,.cls-3{fill:#444;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.51,10C173.44-6.52,125.93-2.4,87.18,21.25,39.39,50.43,22.55,108.16,7.71,159.08c-2.4,8.22-4.67,16-7,23.55A12.57,12.57,0,0,0,12.57,199.3h14.3a22.58,22.58,0,0,1,22.55,22.56v40.31c0,20.75,16.49,35.82,39.21,35.82h29a45.69,45.69,0,0,0,34.92-16.45,7.81,7.81,0,0,0,5,3.31A245.48,245.48,0,0,0,200,288.71c18.41,0,39.11-2.47,54-11.38a7.86,7.86,0,1,0-8.08-13.49c-27.58,16.54-84.75,5.68-85.34,5.57h0l5.36-8.94A249.54,249.54,0,0,0,200.17,263c18.51,0,39-2.53,53.76-11.41a7.86,7.86,0,1,0-8.08-13.49c-18.53,11.12-50.43,9.85-69.35,7.83a34.8,34.8,0,0,1,22.39-9c27.44-.53,75.59-9.16,94.74-60l.26.08c.4-1.27.74-2.54,1.09-3.81a0,0,0,0,0,0,0,157.19,157.19,0,0,0,5.55-42.27h0C300.56,75.46,268.73,29.11,217.51,10Zm62.18,159.27h0c-8.15,23.4-28.87,51-81.11,52a50.49,50.49,0,0,0-42.45,24.85l-13,21.77a29.86,29.86,0,0,1-25.5,14.45h-29c-11.7,0-23.48-6.21-23.48-20.1V221.86a38.33,38.33,0,0,0-38.28-38.28h-10c2-6.5,3.92-13.14,5.95-20.09,14.05-48.19,30-102.8,72.56-128.81C130,13.55,172.47,9.92,212,24.69c44.93,16.81,72.84,57.5,72.84,106.2A140.79,140.79,0,0,1,279.69,169.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98,144.07c0-11.29-6.74-20.44-15.06-20.44-16,0-17.07,40.87,0,40.87C91.24,164.5,98,155.36,98,144.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.36,64.66a59.4,59.4,0,1,0,59.4,59.39A59.46,59.46,0,0,0,198.36,64.66Zm0,59.39v43.67a43.73,43.73,0,0,1-43.68-43.67h43.68V80.39A43.72,43.72,0,0,1,242,124.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.64,292.27a7.88,7.88,0,0,1-2.7,10.8c-14.86,8.91-35.56,11.39-54,11.39a243.3,243.3,0,0,1-42.46-3.88,7.87,7.87,0,0,1,3-15.44c.58.12,57.76,11,85.34-5.55a7.86,7.86,0,0,1,10.78,2.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestedIc);
export default __webpack_public_path__ + "static/media/tested-ic.2aff0cc9ef7b0d651eabeed8d5c0e09a.svg";
export { ForwardRef as ReactComponent };